import type { SVGProps } from 'react';

const SvgEnter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M19 5c-.55 0-1 .45-1 1v6c0 .55-.45 1-1 1H7.41l2.29-2.29A.996.996 0 1 0 8.29 9.3l-4 3.99a.996.996 0 0 0 0 1.41l4 4c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L7.42 15h9.59c1.65 0 3-1.35 3-3V6c0-.55-.45-1-1-1z"
    />
  </svg>
);
export default SvgEnter;
